module.exports = __webpack_public_path__ + "img/2_75.47c0c8ac.png";